import { render, staticRenderFns } from "./SkeletonPlan.vue?vue&type=template&id=70062d28&scoped=true&"
import script from "./SkeletonPlan.vue?vue&type=script&lang=js&"
export * from "./SkeletonPlan.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonPlan.vue?vue&type=style&index=0&id=70062d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70062d28",
  null
  
)

export default component.exports